import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { createMuiTheme,responsiveFontSizes } from '@material-ui/core/styles';
import { ThemeProvider } from '@material-ui/styles';

let theme = createMuiTheme({
    palette: {
      primary: {
        main: '#00b277',
        contrastText: '#1a1b1c',
      },
      secondary: {
        main: '#1a1c1d',
        // dark: will be calculated from palette.secondary.main,
        contrastText: '#ffffff',
      },
      // error: will use the default color
    },
  
    typography: {
      fontFamily: [
        'Roboto',
        '-apple-system',
        'BlinkMacSystemFont',
        '"Segoe UI"',
        '"Helvetica Neue"',
        'Arial',
        'sans-serif',
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
      ].join(','),
      primary:'#ffffff',
      secondary:'#a8a8a8'
    },
});

theme = responsiveFontSizes(theme)
ReactDOM.render(<ThemeProvider theme={theme}><App /></ThemeProvider>, document.getElementById('root'));


